<template>
    <a href="#" v-on:click="printChecklist"><b>Print</b></a>
</template>

<script>
export default {
    name: 'PrintButton',
    methods: {
        printChecklist: function(event) {
            window.print();
        }
    }

}
</script>